export class ResponseModel {
    data: Object
    status: Number
    statusText: String
    headers: Object
    config: Object
    request: Object

    static STATUS_OK: Number = 200
    static STATUS_OK_MESSAGE: String = 'A solicitação foi concluída com sucesso.'

    static STATUS_NO_CONTENT: Number = 204
    static STATUS_NO_CONTENT_MESSAGE: String = 'Sem conteúdo'

    static STATUS_CREATED: Number = 201
    static STATUS_CREATED_MESSAGE: String = 'Um novo recurso foi criado com sucesso.'
    
    static STATUS_BAD_REQUEST: Number = 400
    static STATUS_BAD_REQUEST_MESSAGE: String = 'O pedido foi inválido.'
    
    static STATUS_UNAUTHORIZED: Number = 401
    static STATUS_UNAUTHORIZED_MESSAGE: String = 'A solicitação não incluiu um token de autenticação ou o token de autenticação expirou.'
    
    static STATUS_FORBIDDEN: Number = 403
    static STATUS_FORBIDDEN_MESSAGE: String = 'O cliente não tem permissão para acessar o recurso solicitado.'
    
    static STATUS_NOT_FOUND: Number = 404
    static STATUS_NOT_FOUND_MESSAGE: String = 'O recurso solicitado não foi encontrado.'
    
    static STATUS_METHOD_NOT_ALLOWED: Number = 405
    static STATUS_METHOD_NOT_ALLOWED_MESSAGE: String = 'O método HTTP na solicitação não era suportado pelo recurso. Por exemplo, o método DELETE não pode ser usado com a API do agente.'
    
    static STATUS_CONFLICT: Number = 409
    static STATUS_CONFLICT_MESSAGE: String = 'A solicitação não pôde ser concluída devido a um conflito. Por exemplo, a API de pasta do Content Store do POST não pode ser concluída se o nome do arquivo ou da pasta já existir no local pai.'

    static STATUS_UNPROCESSABLE_ENTITY: Number = 422
    static STATUS_UNPROCESSABLE_ENTITY_MESSAGE: String = 'Não foi possível processar a solitação com os dados presentes'
    
    static STATUS_INTERNAL_SERVER_ERROR: Number = 500
    static STATUS_INTERNAL_SERVER_ERROR_MESSAGE: String = 'A solicitação não foi concluída devido a um erro interno no lado do servidor.'
    
    static STATUS_GATEWAY_ERROR: Number = 502
    static STATUS_GATEWAY_ERROR_MESSAGE: String = 'GATEWAY_ERROR.'

    static STATUS_SERVICE_UNAVAILABLE: Number = 503
    static STATUS_SERVICE_UNAVAILABLE_MESSAGE: String = 'O servidor esta indisponível.'
}